<div class="flex flex-col xl:flex-row gap-0 py-16">
  <div class="rounded-xl xl:rounded-3xl overflow-clip xl:w-1/2 xl:ml-8 z-10 aspect-card-horizontal">
    <div class="-ml-[2%] -mr-[2%] -mt-[4%] -mb-[4%]">
      <img src={{cardImage}} class="w-[104%] h-[108%]" />
    </div>
  </div>

  <div
    class="flex flex-col justify-center bg-slate-200 text-gray-600 xl:w-1/2 xl:-ml-8 -mt-8 xl:mt-0 rounded-xl xl:rounded-3xl overflow-clip text-center pt-8 xl:pt-0">


      <div *ngIf="lookupObject?.status === cardStatus.Active" class="flex flex-col grow md:justify-center p-4">

        <p *ngIf="lookupObject?.sender">Carta regalo da <b>{{lookupObject?.sender}}</b></p>

        <div class="card-amount active">
          <h1>{{currentAmount}}</h1>
          <p *ngIf="showsOriginalAmount" class="text-md ">disponibili su <span
              class="line-through">{{initialAmount}}</span></p>
        </div>

        <div class="flex flex-col gap-2">
          <p>Emessa da <b>{{lookupObject?.partner_name}}.</b></p>
          <p *ngIf="lookupObject?.expires_at">Scade il <b>{{expiration | date: 'dd/MM/yyyy'}}.</b></p>
        </div>
      </div>


      <div *ngIf="lookupObject?.status === cardStatus.Redeemed" class="flex flex-col grow md:justify-center p-4 text-gray-600">

        <h2>La carta regalo è stata utilizzata.</h2>

        <p *ngIf="lookupObject?.sender" class="pt-4">Carta regalo da <b>{{lookupObject?.sender}}</b></p>
        
        <div class="card-amount disabled">
          <h1>{{currentAmount}}</h1>
          <p *ngIf="showsOriginalAmount" class="text-md"><span
              class="line-through">{{initialAmount}}</span></p>
        </div>

        <div class="flex flex-col gap-2">
          <p>Emessa da <b>{{lookupObject?.partner_name}}.</b></p>
        </div>
      </div>


      <div *ngIf="lookupObject?.status === cardStatus.Expired" class="flex flex-col grow md:justify-center p-4 gap-2 text-gray-600">

        <h2>Scaduta il {{expiration | date: 'dd/MM/yyyy'}}.</h2>
        
        <p *ngIf="lookupObject?.sender" class="pt-4">Carta regalo da <b>{{lookupObject?.sender}}</b></p>

        <div class="card-amount disabled">
          <h1>{{currentAmount}}</h1>
          <p *ngIf="showsOriginalAmount" class="text-md"><span
              class="line-through">{{initialAmount}}</span></p>
        </div> 

        <div class="flex flex-col gap-2">
          <p>Emessa da <b>{{lookupObject?.partner_name}}.</b></p>
        </div>
      </div>

    <div class="low-band">
      <p class="w-full text-center">ID Carta <span class="font-bold">{{lookupObject?.id}}</span> </p>
    </div>
  </div>


</div>